<template>
  <div id="moves-wrap">
    <h2 v-if="!forOverview">Moves</h2>
    <p
      v-if="forOverview"
      class="subnote"
      style="width: 90%; text-align: left; margin-bottom: 0;"
    >Only selected Advanced and Expert moves are shown here.</p>

    <CharacterMoveSet
      v-for="(moveset, index) in Object.keys(forOverview ? characterMoves : possibleMoves)"
      :key="index"
      :moveset="forOverview ? characterMoves[moveset] : possibleMoves[moveset]"
      :movesetVisible="show[moveset]"
      :moveType="moveset"
      :subtext="moveset === 'advanced' ? advancedMovesetSubtext 
        : moveset === 'expert' ? expertMovesetSubtext 
        : ''"
      @showMoveset="showMoveset(moveset)"
    />

    <div
      v-if="spellCharacter ? (forOverview ? characterSpells : possibleSpells) : false"
      id="spells"
    >
      <h3 @click="showMoveset('spells')">Spells</h3>
      <div v-show="show.spells">
        <div
          v-for="(spellSet, index) in Object.keys(forOverview ? characterSpells : possibleSpells)"
          :key="index"
        >
          <h4 @click="setSpellsetVisible(index)">{{ formatSpellSetName(spellSet) }}</h4>
          <CharacterSpell
            v-for="spell in (forOverview ? characterSpells[spellSet] : possibleSpells[spellSet])"
            v-show="showSpells[index]"
            :key="spell.title"
            :spell="spell"
          />
        </div>
      </div>
    </div>

    <SaveButtons v-if="!forOverview" @clear="clearMoves" />
  </div>
</template>

<script>
import CharacterMoveSet from "./CharacterMoveSet.vue";
import CharacterSpell from "./CharacterSpell.vue";
import SaveButtons from "../../util/SaveButtons";

// Starting moves, Advanced moves
export default {
  name: "Moves",
  props: ["filterMoves", "forOverview"],
  components: {
    CharacterMoveSet,
    CharacterSpell,
    SaveButtons
  },
  data() {
    return {
      show: {
        basic: false,
        special: false,
        starting: false,
        advanced: false,
        expert: false,
        spells: false
      },
      showSpells: []
    };
  },
  created() {
    this.advancedMovesetSubtext =
      "When you gain a level from 2-10, you may choose from these moves.";
    this.expertMovesetSubtext =
      "When you gain a level from 6-10, you may choose from these moves.";
    this.showSpells = new Array(Object.keys(this.possibleMoves).length).fill(
      false
    );
  },
  methods: {
    showMoveset: function(set) {
      Object.keys(this.show).map(key => {
        if (key == set) {
          this.show[key] = !this.show[key];
        } else {
          this.show[key] = false;
        }
      });
    },
    setSpellsetVisible: function(i) {
      this.$set(this.showSpells, i, !this.showSpells[i]);
    },
    clearMoves: function() {
      this.possibleMoves.advanced.map(move => (move.have = false));
      this.possibleMoves.expert.map(move => (move.have = false));
      this.$store.dispatch("clearCharacterMoves");
    },
    formatSpellSetName: function(spellSetName) {
      let toUpperCase = [];
      for (let i = 0; i < spellSetName.length; i++) {
        if (
          spellSetName.charCodeAt(i) <= 90 &&
          spellSetName.charCodeAt(i) >= 65
        ) {
          toUpperCase.push(i);
        }
      }
      if (toUpperCase.length > 0) {
        let tempName = "";
        let lastIndex = 0;
        toUpperCase.forEach(index => {
          tempName +=
            spellSetName.charAt(lastIndex).toUpperCase() +
            spellSetName.substring(lastIndex + 1, index) +
            " ";
          lastIndex = index;
        });
        tempName +=
          spellSetName.charAt(lastIndex).toUpperCase() +
          spellSetName.substring(lastIndex + 1, spellSetName.length);
        return tempName;
      } else {
        return (
          spellSetName.charAt(0).toUpperCase() +
          spellSetName.substring(1, spellSetName.length)
        );
      }
    }
  },
  computed: {
    possibleMoves() {
      if (this.$store.state.character.class) {
        return this.$store.getters.getPossibleMoves(
          this.$store.state.character.class.toLowerCase()
        );
      } else {
        return this.$store.getters.getNormalMoves;
      }
    },
    characterMoves() {
      if (this.$store.state.character.class) {
        return this.$store.getters.getCharacterMoves;
      } else {
        return this.$store.getters.getNormalMoves;
      }
    },
    spellCharacter() {
      return this.$store.getters.ifSpellCharacter;
    },
    possibleSpells() {
      if (this.$store.state.character.class) {
        return this.$store.getters.getPossibleSpells(
          this.$store.state.character.class.toLowerCase()
        );
      } else {
        return null;
      }
    },
    characterSpells() {
      return this.$store.getters.getCharacterSpells;
    }
  },
  watch: {
    move: {
      handler: function(val) {
        val; // Don't care about the handler, just need the 'deep: true'
      },
      deep: true
    }
  }
};
</script>
<style lang="css">
#moves-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
  width: 90%;
}

#moves-wrap > h2 {
  text-align: center;
}

#moves-wrap > h2 {
  margin-bottom: 0;
  width: 90%;
}

#spells {
  width: 90%;
  text-align: left;
}

#spells > h3,
#spells h4,
#spells > h5 {
  margin: 0.5em 0;
  text-align: left;
}

#spells h4 {
  margin-left: 1em;
}

#spells > h5 {
  margin-top: 0;
  border-bottom: 1px solid black;
}

.spell-title {
  margin-left: 1em;
  display: flex;
}

.spell-title .have-spell {
  width: 1em;
  height: 1em;
  background: white;
}
</style>